<div
  class="auth"
  style="
    background-image: url(../../../assets/images/originals/bg9.jpg);
    background-repeat: no-repeat;
    background-size: auto;
    background-position: center center;
  "
>
  <div class="row d-flex g-0">
    <div class="d-none d-lg-block login-sidebar col-lg-4 px-5">
      <div class="slider-light">
        <div
          class="position-relative h-100 d-flex justify-content-center align-items-center"
        >
          <div class="slide-img-bg"></div>
          <div class="slider-content text-light">
            <h3>{{ "Form.THANK_YOU_TITLE" | translate }}</h3>
            <p>
              {{ "Form.Login.ARCHITECTURE_INFO_MESSAGE" | translate }}
            </p>
            <div>
              <ul>
                <li style="margin-bottom: 0.6rem">
                  <strong>{{ "Form.Login.POINT1HEADING" | translate }}</strong>
                  {{ "Form.Login.Point1" | translate }}
                </li>
                <li style="margin-bottom: 0.6rem">
                  <strong>{{ "Form.Login.POINT2HEADING" | translate }}</strong>
                  {{ "Form.Login.Point2" | translate }}
                </li>
                <li style="margin-bottom: 0.6rem">
                  <strong>{{ "Form.Login.POINT3HEADING" | translate }}</strong>
                  {{ "Form.Login.Point3" | translate }}
                </li>
                <li style="margin-bottom: 0.6rem">
                  <strong>{{ "Form.Login.POINT4HEADING" | translate }}</strong>
                  {{ "Form.Login.Point4" | translate }}
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      class="d-md-flex d-sm-block justify-content-center align-items-center col-md-12 col-lg-8 forgot-password"
    >
      <div class="mx-auto app-login-box col-md-6 card p-5">
        <h4 class="mb-4 text-center">
          <img src="../../../assets/images/logo-blue.png" width="200" />
        </h4>

        <h4 class="mb-1">Set Password</h4>

        <div>
          <form [formGroup]="form" class="needs-validation">
            <div class="position-relative row form-group">
              <label for="password_id" class="col-sm-4 col-form-label"
                >{{ "Form.PASSWORD" | translate }}
                <span class="text-danger">*</span></label
              >
              <div class="col-sm-8">
                <input
                  formControlName="password"
                  name="password"
                  id="password_id"
                  placeholder="{{ 'Form.Placeholder.PASSWORD' | translate }}"
                  type="password"
                  class="form-control"
                  required
                />
                <div
                  *ngIf="submitted && f.password.errors"
                  class="invalid-feedback"
                >
                  <div *ngIf="f.password.errors.required">
                    {{ "Form.Error.PASSWORD" | translate }}
                  </div>
                  <div *ngIf="f.password.errors.minlength">
                    {{ "Form.Error.PASSWORDError" | translate }}
                  </div>
                  <div *ngIf="f.password.errors.pattern">
                    {{ "Form.Error.InavlidPass" | translate }}
                  </div>
                </div>
              </div>
            </div>

            <div class="position-relative row form-group">
              <label for="confirm_password_id" class="col-sm-4 col-form-label"
                >{{ "Form.CONFIRM_PASSWORD" | translate }}
                <span class="text-danger">*</span></label
              >
              <div class="col-sm-8">
                <input
                  formControlName="confirmPassword"
                  name="confirmPassword"
                  id="confirm_password_id"
                  placeholder="{{
                    'Form.Placeholder.CONFIRM_PASSWORD' | translate
                  }}"
                  type="password"
                  class="form-control"
                  required
                />
                <div
                  *ngIf="submitted && f.confirmPassword.errors"
                  class="invalid-feedback"
                >
                  <div *ngIf="f.confirmPassword.errors.required">
                    {{ "Form.Error.CONFIRM_PASSWORD" | translate }}
                  </div>
                  <div *ngIf="f.confirmPassword.errors.match">
                    {{ "Form.Error.CONFIRM_PASSWORD_Error" | translate }}
                  </div>
                </div>
              </div>
            </div>

            <div class="position-relative row form-check">
              <div
                class="col-sm-12 offset-sm-2 text-center justify-content-center"
              >
                <button
                  class="btn btn-primary"
                  style="margin-right: 10px"
                  type="submit"
                  (click)="onSubmit()"
                >
                  {{ "Form.SAVE" | translate }}
                </button>
                <button class="btn btn-secondary" (click)="onReset()">
                  {{ "Form.CANCEL" | translate }}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
